import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { catchError, map, tap } from 'rxjs/operators';
import { SobreprimasModel } from '../../../models/sobreprimas-res.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SobreprimasService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Recuperar sobre primas
   * @params code
   */
  getSobreprimaList(code: { idProducto: number, idPortalWeb: number }): Observable<any> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
    };
    const obj: any = code;
    headerConfig.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.sobreprimasListar.name,
      headerConfig
    ).pipe(
      map((sobreprimasList: any) => {
        const sobreprimas: any = sobreprimasList.map(el => new SobreprimasModel(el));
        return sobreprimas;
      })
    );
  }
}
